module.exports = __webpack_public_path__ + "img/icon_06.e7a9fd8d.svg";